import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const subTextColor = useColorModeValue('gray.600', 'gray.400');
  const inputBgColor = useColorModeValue('white', 'whiteAlpha.50');
  const headingBgColor = useColorModeValue('white', 'navy.800');
  const hoverBgColor = useColorModeValue('gray.50', 'whiteAlpha.50');
  const selectedBgColor = useColorModeValue('blue.50', 'blue.900');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const previewBg = useColorModeValue('white', 'gray.800');

  // Additional colors for store-sync components
  const cardBgColor = useColorModeValue('white', 'navy.800');
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const dividerColor = useColorModeValue('gray.300', 'whiteAlpha.300');
  const buttonPrimaryBg = useColorModeValue('blue.500', 'blue.400');
  const buttonPrimaryHover = useColorModeValue('blue.600', 'blue.500');

  return {
    bgColor,
    hoverBg,
    previewBg,
    backgroundCardColor,
    textColor,
    borderColor,
    subTextColor,
    inputBgColor,
    headingBgColor,
    hoverBgColor,
    selectedBgColor,
    cardBgColor,
    inputColor,
    placeholderColor,
    dividerColor,
    buttonPrimaryBg,
    buttonPrimaryHover,
  };
};
